const PATH = '/:f([a-z0-9-]{0,}?)?-:id([a-z0-9]{6,})';

export default {
  path: PATH,

  load: (context: any, params: any) => import(/* webpackChunkName: 'cdp' */ './index'),
};
